import { React, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form, Field } from "formik";
import {
  Col,
  Container,
  Row,
  Button,
} from "reactstrap";
import { ReactstrapInput } from "reactstrap-formik";

import { sendAddressBookLogin } from "../../store/address-book-actions";

import * as Yup from "yup";

function AddressBookLoginForm() {
  const dispatch = useDispatch();

  const addressBookState = useSelector((state) => state.addressBook);

  // init form validation schema
  const formSchema = Yup.object().shape({
    emailAddress: Yup.string().required("Required"),
    password: Yup.string().required("Required"),
  });

  function formSubmitHandler(values) {
    dispatch(
      sendAddressBookLogin({
        EmailAddress: values.emailAddress,
        Password: values.password,
      })
    );
  }

  return (
    <div>
      <p><strong>Please Sign In</strong></p>
      {(addressBookState.LoginAttemptResponse) && (
        <p style={{ color: '#ff0000' }}>
          {addressBookState.LoginAttemptResponse}
        </p>
      )}
      <Formik
        initialValues={{
          emailAddress: "",
          password: "",
        }}
        validationSchema={formSchema}
        onSubmit={formSubmitHandler}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form className="text-start address-book-login-form">
            <Container className="cfg-form-section">
              <Row className="mb-4">
                <Col xs="12">
                  <label className="required" htmlFor="emailAddress">
                    Email Address:
                  </label>
                  <Field
                    name="emailAddress"
                    id="emailAddress"
                    component={ReactstrapInput}
                    onBlur={(e) => {
                      handleBlur(e);
                    }}
                  />
                </Col>
              </Row>
              <Row className="mb-4">
                <Col xs="12">
                  <label className="required" htmlFor="password">
                    Password:
                  </label>
                  <Field
                    name="password"
                    id="password"
                    type="password"
                    component={ReactstrapInput}
                    onBlur={(e) => {
                      handleBlur(e);
                    }}
                  />
                </Col>
              </Row>
              <Row className="mb-4">
                <Col xs="12">
                  <Button type="submit" size="sm" color="primary">
                    Log In
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddressBookLoginForm;
